import { c as _c } from "react/compiler-runtime";
import { type CustomDialogProps, Dialog as DialogBase } from '@shared/ui-components/dialog/dialog';
import { withLoaderDialogComponent } from '@shared/ui-components/with-loader-dialog-component/with-loader-dialog-component';
import { Loader } from '../loader/loader';
export const Dialog = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Loader isInner={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = withLoaderDialogComponent(DialogBase, {
      ...props,
      loader: t0
    });
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};